<template>
    <div class="products">
        <img src="../store/member_poster.jpg" alt=""></img>
  
    </div>
</template>

<script setup>
import { ref } from 'vue'



</script>
<style scoped>
.products{
    font-size: 0;
}
</style>